<template>
  <div class="bulletinBox" v-show="this.bulletinList.length">
    <!-- 公告 -->
    <div class="bulletin regular" @click.prevent.stop="toggleDialog(true)">
      <img class="logo" src="@img/lb2.png" :alt="lbAlt" />
      <transition name="announc">
        <template v-for="(item, index) in bulletinList">
          <p
            v-if="index === currentIndex"
            :key="index"
            class="bulletinMessage"
            :class="{
              bulletinMessage_ar: language_code === 'AR',
            }"
          >
            <span>{{ item.title }}</span>
          </p>
        </template>
      </transition>
      <img
        id="bulletin_arrow"
        :class="{ active: bulletins && isPc }"
        src="@img/arrow2.png"
        :alt="arrowAlt"
      />
    </div>

    <!-- PC弹窗 -->
    <transition name="pop-up">
      <div v-show="isPc && bulletins" class="pc_show regular">
        <span>{{ bulletinList[currentIndex]?.content || '' }}</span>
      </div>
    </transition>

    <!-- 移动端弹窗 -->
    <Dialog
      :visible.sync="showMobileDialog"
      :title="$t('game.announcement')"
      :confirmText="$t('game.confirm')"
      :show-close="true"
      @cancel="toggleDialog(true)"
      @confirm="toggleDialog(true)"
      @close="toggleDialog(false)"
      @touchmove.native.prevent
    >
      <div class="bulletin_content" @touchmove.stop v-touchmove>
        <span>{{ bulletinList[currentIndex]?.content || '' }}</span>
      </div>
    </Dialog>
  </div>
</template>

<script>
import { getAnnouncement } from '@/api/index.js'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'announcement',
  props: ['language_code', 'currency'],
  data() {
    return {
      displayed: true,
      isPc: false,
      bulletins: false,
      currentIndex: 0,
      swiperInterval: null,
    }
  },
  watch: {
    currency() {
      this.getBulletinList()
    },
  },
  computed: {
    ...mapState('config', ['bulletinList']),
    ...mapState({
      gameId: (state) => state.app.gameId,
      seoLang: (state) => state.app.seoLang,
    }),
    showMobileDialog: {
      get() {
        return !this.isPc && this.bulletins
      },
      set(value) {
        this.bulletins = value
      },
    },
    lbAlt() {
      const keys = this.seoLang.bulletin || []
      try {
        return keys
          .map((key) => (this.$te(key) && this.$t(key)) || '')
          .filter((msg) => !!msg)
          .join(', ')
      } catch (error) {
        return ''
      }
    },
    arrowAlt() {
      const keys = this.seoLang.bulletin_arrow || []
      try {
        return keys
          .map((key) => (this.$te(key) && this.$t(key)) || '')
          .filter((msg) => !!msg)
          .join(', ')
      } catch (error) {
        return ''
      }
    },
  },
  created() {
    this.isPc = this.detectDeviceType() !== 'Mobile'
  },
  mounted() {
    this.getBulletinList()

    // 监听窗口大小变化，更新设备类型
    window.addEventListener('resize', this.updateDeviceType)

    // PC时监听全局点击事件
    if (this.isPc) {
      document.body.addEventListener('click', this.closeBulletin)
    }
  },
  beforeDestroy() {
    clearInterval(this.swiperInterval)
    window.removeEventListener('resize', this.updateDeviceType)
    if (this.isPc) {
      document.body.removeEventListener('click', this.closeBulletin)
    }
  },
  methods: {
    ...mapActions('config', ['FETCH_BULLETIN_LIST']),
    // 获取公告列表
    async getBulletinList() {
      try {
        await this.FETCH_BULLETIN_LIST({
          game_id: process.env.VUE_APP_GAME_ID,
          currency: this.currency,
          language_code: this.language_code,
        })
        this.startSwiper()
      } catch (error) {
        console.error(error)
      }
    },

    // 激活公告信息
    activateBulletin() {
      setTimeout(() => {
        const messages = document.querySelectorAll('.bulletinMessage')
        if (messages.length) {
          // messages[this.currentIndex].classList.add('active')
          this.startSwiper()
        }
      }, 100)
    },

    // 切换设备类型
    detectDeviceType() {
      return /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(
        navigator.userAgent
      ) || window.innerWidth < 1024
        ? 'Mobile'
        : 'PC'
    },

    updateDeviceType() {
      this.isPc = this.detectDeviceType() !== 'Mobile'
    },

    // 切换公告弹窗状态
    toggleDialog(isSet) {
      isSet && (this.bulletins = !this.bulletins)

      if (this.bulletins) {
        // 打开时，清除定时器
        this.swiperInterval && clearInterval(this.swiperInterval)
      } else {
        // 关闭时，启动定时器
        this.startSwiper()
      }

      if (!this.isPc) {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        document.body.style.position = this.bulletins ? 'fixed' : ''
        document.body.style.top = this.bulletins ? `-${scrollTop}px` : ''
        window.scrollTo(0, -scrollTop)
      }
    },

    // 关闭公告
    closeBulletin() {
      if (this.bulletins) {
        this.bulletins = false
        this.startSwiper()
      }
    },

    // 启动公告自动滚动
    startSwiper() {
      if (this.bulletinList.length <= 1) return

      this.swiperInterval && clearInterval(this.swiperInterval)

      this.swiperInterval = setInterval(() => {
        const len = this.bulletinList.length
        this.currentIndex = (this.currentIndex + 1) % len
      }, 3000)
    },
  },
}
</script>

<style scoped lang="less">
/* CSS 保持不变 */
.bulletinBox {
  position: relative;
  z-index: 10;
}

.bulletin {
  width: 100%;
  height: 40px;
  background: #fff;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin-top: 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 0 8px;
  justify-content: space-between;
  cursor: pointer;
  position: relative;
}

.bulletin .logo {
  width: 32px;
}

.bulletin .bulletinMessage {
  width: calc(100% - 70px);
  font-size: 14px;
  font-weight: 400;
  color: rgba(98, 103, 107, 1);
  transition: all 0.3s ease;
  position: absolute;
  left: 46px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  box-sizing: border-box;
}

#bulletin_arrow {
  width: 7px;
  transition: all 0.6s ease;
  transform: rotate(0deg);
  margin: 0 2px;
}

#bulletin_arrow.active {
  transform: rotate(90deg);
}

.pc_show {
  position: absolute;
  background: #ffffff;
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
  box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  z-index: 2;
  font-size: 14px;
  line-height: 1.5;
  color: rgba(98, 103, 107, 1);
  min-height: 6rem;
  max-height: 30vh;
  overflow-y: auto;
  top: 52px;
}
.bulletin_content {
  width: 100%;
  padding: 8px 12px;
  min-height: 160px;
  max-height: 300px;
  background: rgba(242, 244, 248, 1);
  overflow-y: scroll;
  box-sizing: border-box;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.4;
  color: #62676b;
}

.bulletin_content span {
  white-space: pre-line;
}

.announc-enter-active,
.announc-leave-active {
  transition: all 0.3s ease-in-out;
}

.announc-enter {
  opacity: 0;
  transform: translateY(50%);
}
.announc-leave-to {
  opacity: 0;
  transform: translateY(-50%);
}
</style>
